import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col} from 'antd';
import _ from 'underscore';

const FormItem = Form.Item;

const Profile = () => {

  let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));
   console.log(employeeData);
   let loc = '';
   if(employeeData && employeeData.emp_location){
     let custloc = employeeData.emp_location[1];
     let splitLoc = custloc.split(',');
     loc = splitLoc[splitLoc.length-1];
   }

   return (

    <div style={{ padding: 30, paddingTop: 0 }}>
      {/* Heading Text Row */}
      <Row>
        <Col span={6}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>Profile</h3>
        </Col>
        <Col span={8}>
        </Col>
      </Row>

      <div>

        {/* Employee Information */}
        <Card style={{ background: "white", marginTop: 10 }}>
          <div className='row' style={{ fontSize: 15, padding:10 }}>
            <div className='col-md-12' >
              <h4><u>Employee Information</u></h4>

              {/* Name */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Employee Id:</b>
                </div>
                <div className='col-md-10' >
                  <p>{employeeData.id} {" "} </p>
                </div>
              </div>
              <br />

              {/* Age */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Job Title :</b>
                </div>
                <div className='col-md-10' >
                  <p> {employeeData.Job_Title}</p>
                </div>
              </div>
              <br />

              {/* Sex */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Location:</b>
                </div>
                <div className='col-md-10' >
                  <p>{loc}</p>
                </div>
              </div>

            </div>
          </div>
        </Card>

        <Card style={{ background: "white", marginTop: 10 }}>

          <div className='row' style={{ fontSize: 15, padding:10 }}>
            <div className='col-md-12' >
              <h4><u>Personal Information</u></h4>

              {/* Name */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Name:</b>
                </div>
                <div className='col-md-10' >
                  <p>{employeeData.first_name} {" "} {employeeData.last_name}</p>
                </div>
              </div>
              <br />

              {/* Age */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Date of Birth :</b>
                </div>
                <div className='col-md-10' >
                  <p> {employeeData.age}</p>
                </div>
              </div>
              <br />

              {/* Sex */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Sex :</b>
                </div>
                <div className='col-md-10' >
                  <p>{employeeData.Sex}</p>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Card style={{ background: "white", marginTop: 10 }}>

          {/* Contact Information */}
          <div className='row' style={{ fontSize: 15, padding:10 }}>
            <div className='col-md-12' >
              <h4><u>Contact Information</u></h4>

              {/* Phone Number */}
              {/* <div className='row'>
                <div className='col-md-2' >
                  <b>Address :</b>
                </div>
                <div className='col-md-10' >
                   <p>{employeeData.street}
                    {employeeData.street1}
                    {employeeData.city}
                    {employeeData.state_id[1]},{employeeData.country_id[1]}</p> 
                    <p>{employeeData.emp_location}</p>
                </div>
              </div> */}
              {/* <br /> */}
              <div className='row'>
                {/*  */}
                <div className='col-md-2' >
                  <b>Phone Number:</b>
                </div>
                <div className='col-md-10' >
                  <p>{employeeData.Mobile}</p>
                </div>
              </div>
              <br />
              {/* email Address */}
              <div className='row'>
                <div className='col-md-2' >
                  <b>Email Address :</b>
                </div>
                <div className='col-md-10' >
                  <p>{employeeData && employeeData.email}</p>
                </div>
              </div>
              <br />

              {/* <div className='row'>
              <div className='col-md-2' >
            <b>Clinic Manager Name :</b> 
            </div>
           <div className='col-md-10' >
            {/* <p>{employeeData && employeeData.clinic_manager_name}</p> */}
              {/* </div></div>
            <br/>
            <div className='row'>
              <div className='col-md-2' >
            <b>Clinic Manager Email :</b>
            </div>
           <div className='col-md-10' > */}
              {/* <p>{employeeData && employeeData.clinic_manager_email}</p> */}
              {/* </div>
             </div> */}
              {/* <p>Clinic Manager Phone Number : {employeeData && employeeData.clinic_manager_name}</p> */}
              {/* <p>Number To Be Tested : {employeeData && employeeData.no_to_be_tested}</p>
            <p>Status : {employeeData && employeeData.event_status}</p>
            */}
              {/* </div>
           </div>
           <br/>
               <hr/>
          <br/>
           <div style={{fontSize: 15}}>   
          <h4><u>Day/Hours of Operation</u></h4>
          <div className='row'>
          
              <div className='col-md-6' > */}
              {/* <p><b>Monday Open Time :</b> {employeeData && employeeData.mon_open_time}:00 hrs</p> */}
              {/* </div>
         <div className='col-md-6' > */}
              {/* <p><b>Monday Close Time :</b> {employeeData && employeeData.mon_close_time}:00 hrs</p> */}
              {/* </div>
         </div>
         <br/>
         <div className='row'>
         <div className='col-md-6' >
         {/* <p><b>Tuesday Open Time :</b> {employeeData && employeeData.tues_open_time}:00 hrs</p> */}
              {/* </div>
         <div className='col-md-6' > */}
              {/* <p><b>Tuesday Close Time :</b> {employeeData && employeeData.tues_close_time}:00 hrs</p> */}
              {/* </div>
         </div>
         <br/>
         <div className='row'>
         <div className='col-md-6' > */}
              {/* <p><b>Wednesday Open Time :</b> {employeeData && employeeData.wed_open_time}:00 hrs</p> */}
              {/* </div>
         <div className='col-md-6' > */}
              {/* <p><b>Wednesday Close Time :</b> {employeeData && employeeData.wed_close_time}:00 hrs</p> */}
              {/* </div>
         </div>
         <br/>
         <div className='row'>
         <div className='col-md-6' > */}
              {/* <p><b>Thursday Open Time :</b> {employeeData && employeeData.thr_open_time}:00 hrs</p> */}
              {/* </div>
         <div className='col-md-6' > */}
              {/* <p><b>Thursday Close Time :</b> {employeeData && employeeData.thr_close_time}:00 hrs</p> */}
              {/* </div>
         </div>
         <br/>
         <div className='row'>
         <div className='col-md-6' > */}
              {/* <p><b>Friday Open Time :</b> {employeeData && employeeData.fri_open_time}:00 hrs</p> */}
              {/* </div>
         <div className='col-md-6' > */}
              {/* <p><b>Friday Close Time :</b> {employeeData && employeeData.fri_close_time}:00 hrs</p> */}
            </div>
            {/* //  </div>
         <br/> */}

          </div>
        </Card>
      </div>
    </div>
  );
};

export default Profile;
